<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Abono de pedido</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <div class="datepicker-field">
            <VueCtkDateTimePicker
              id="fecha_abono"
              v-model="modelValue.fecha_abono"
              locale="es"
              no-label
              button-now-translation="Ahora"
              format="YYYY-MM-DD HH:mm"
              formatted="YYYY-MM-DD HH:mm"
              label="Seleccione fecha..."
            />
            <label>Fecha de abono</label>
            <span
              v-if="errores.fecha_abono"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.fecha_abono[0] }}</strong>
            </span>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            id="valor_abono"
            v-model="modelValue.valor_abono"
            placeholder="Escriba un valor..."
          >
            Valor de abono
            <span
              v-if="errores.valor_abono"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.valor_abono[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <p>
            <label for="cobro_oficina">
              <input v-model="modelValue.cobro_oficina" type="checkbox" name="cobro_oficina" id="cobro_oficina"><span>Cobro en oficina</span>
            </label>
          </p>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="form-field">
          <textarea-field
            placeholder="Escriba una observación..."
            id="observacion"
            v-model="modelValue.observacion"
          >
            <span>Observación</span>
            <span
              v-if="errores.observacion"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.observacion[0] }}</strong>
            </span>
          </textarea-field>
        </div>
      </div>
    </div>
    <div class="modal-buttons">
      <button type="button" @click="guardar" class="btn-success">
        <i class="fa fa-save"></i><span>Guardar</span>
      </button>
      <button @click="cancelar" type="button" class="btn-danger btn--text">
        <i class="fa fa-ban"></i><span>Cancelar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: false,
      default: function () {
        return {
          fecha_abono: moment(new Date()).format("YYYY-MM-DD HH:mm"),
          valor_abono: "",
          observacion: "",
          usuario: {
            nombre_usuario: "",
          },
          cobro_oficina: false
        };
      },
    },
    pedidoId: {
      type: String,
      required: false,
      default: "",
    },
  },
  data: function () {
    return {
      modelValue: this.value,
      money: money,
      errores: {},
    };
  },
  methods: {
    guardar: function () {
      let message = '';
      if (this.modelValue.cobro_oficina) 
        message = 'El abono será registrado como cobro de oficina, ¿Deseas continuar?';
      else 
        message = "¿Deseas registrar la información del abono?";
      swal({
        title: message,
        text: "Se guardará los datos ingresados",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          let urlRequest = url + "/logistica/abonos";
          let method = undefined;
          if (this.modelValue.id != null && this.modelValue.id != "") {
            urlRequest += "/" + this.modelValue.id;
            method = "PUT";
          }
          axios
            .post(urlRequest, {
              fecha_abono: this.modelValue.fecha_abono,
              observacion: this.modelValue.observacion,
              valor_abono: this.modelValue.valor_abono,
              pedido_id: this.pedidoId,
              _method: method,
              cobro_oficina: this.modelValue.cobro_oficina
            })
            .then(() => {
              swal("El abono fue registrado exitósamente.", "Aviso", "success");
              this.$emit("abonoAlmacenado");
            })
            .catch(({ response }) => {
              let status = response.status;
              if (status === 422) {
                this.errores = response.data.errors;
                swal("Hay errores en el formulario.", 'Error', 'error');
              } 
              else if (status === 409) {
                swal("El pedido ha superado el numero máximo de abonos por día.", 'Aviso', 'warning');
              }
              else
                swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    cancelar: function () {
      this.$emit("cancelar");
    },
  },
  mounted: function () {
    if (this.modelValue.cobro_oficina === 'S' || this.modelValue.cobro_oficina === 'N') {
      this.modelValue.cobro_oficina = this.modelValue.cobro_oficina === 'S';
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/AbonoPedido.vue